(function () {
  'use strict';

  function isPDPCollapse(section) {
    if (!section) return false;
    return !!section.closest('main-product, [id*="MainProduct"], section.section-main-product, .wt-product, .product-info-wrapper, .product-template');
  }

  function closeOthers(activeTrigger, activeSection) {
    var allSections = document.querySelectorAll('collapsible-section');
    allSections.forEach(function (s) {
      if (s === activeSection) return;
      if (!isPDPCollapse(s)) return;
      var t = s.querySelector('.wt-collapse__trigger');
      if (!t) return;
      if (t.getAttribute('aria-expanded') === 'true') {
        t.click();
      }
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.wt-collapse__trigger');
    if (!trigger) return;
    var section = trigger.closest('collapsible-section');
    if (!section || !isPDPCollapse(section)) return;

    setTimeout(function () {
      var nowOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (!nowOpen) return;
      closeOthers(trigger, section);
    }, 30);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var trigger = e.target.closest('.wt-collapse__trigger');
    if (!trigger) return;
    var section = trigger.closest('collapsible-section');
    if (!section || !isPDPCollapse(section)) return;

    setTimeout(function () {
      var nowOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (!nowOpen) return;
      closeOthers(trigger, section);
    }, 30);
  }, true);
})();
